<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.isActive = 2
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.isActive"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" :value="2"> </el-option>
                  <el-option label="Đang hoạt động" :value="1"> </el-option>
                  <el-option label="Không hoạt động" :value="0"> </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteSourceGroup"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="!isEdit ? 'Thêm nhóm nguồn' : 'Sửa nhóm nguồn'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã nhóm nguồn</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã nhóm nguồn"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:255"
                    name="Mô tả nhóm nguồn"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>

                  <el-switch
                    v-model="form.active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                    placeholder="Nhập thông tin"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateSourceGroup"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addSourceGroup"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import {
  getSourceGroupApi,
  addSourceGroupApi,
  updateSourceGroupApi,
  deleteSourceGroupApi
} from '@/api/Statistics/sourceGroup'
import { Message } from 'element-ui'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderToggleSwitchReadOnly
  },
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: true,
      searchParams: {
        isActive: 2
      },
      defaultForm: {
        code: '',
        desc: '',
        id: null,
        order: 0,
        active: true
      },
      form: {
        code: '',
        desc: '',
        id: null,
        order: 0,
        active: true
      },
      titlePopup: 'Thêm mẫu nhóm nguồn',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },
        {
          headerName: 'Mã nhóm',
          field: 'code',
          width: 100,
          sortable: false
        },
        {
          headerName: 'Tên',
          field: 'desc',
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Hoạt động',
          field: 'active',
          sortable: false,
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.active
            }
          }
        }
      ],

      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBuildingInfo()
    }
  },

  mounted() {
    this.attachData({ isActive: 1 })
  },
  methods: {
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },

    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loaing = true
      let data = await getSourceGroupApi(this.searchParams)
      // bus.$emit("endLoader");
      this.loading = false
      this.rows = data.data
    },
    async addSourceGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addSourceGroupApi(this.form)
        .then(async res => {
          const message = res.message
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateSourceGroup() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateSourceGroupApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteSourceGroup() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteSourceGroupConfirm'), () => {
          deleteSourceGroupApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              // if (this.isActive) {
              //   this.attachData({ isActive: 0 })
              // } else {
              //   this.attachData({ isActive: 1 })
              // }
              this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.titlePopup = 'Sửa nhóm nguồn'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.order = rowData.order
        this.form.id = rowData.id
        this.form.code = rowData.code
        this.form.desc = rowData.desc
        this.form.active = rowData.active
        this.dialogFormVisible = true
      }
    },
    resetBuildingInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
